(function () {

  console.log("Ultimate Shopify Gender Personalization Loaded");

  /*
  =========================================================
  CONFIG
  =========================================================
  */
  
  const STORAGE_KEY = "user_gender"; 
  let memoryGender = null;

  /*
  =========================================================
  FEMALE -> MALE NAME MAP
  =========================================================
   
  */

  //const maleNameMap = {
    /*"Sondra W.": "Sandy W.",
    "Rhayne T.": "Ryan T.",
    "Sharon M.": "Danny M."*/
  //};

  const maleNameMap = window.maleNameMap || {};
  
  /*
  =========================================================
  SAVE GENDER
  =========================================================
  */

  function saveGender(gender) {

	  if (!gender) return;

	  gender = gender.toLowerCase().trim();

	  if (gender.includes("female")) {
		gender = "female";
	  } else if (gender.includes("male")) {
		gender = "male";
	  } else {
		return;
	  }

	  memoryGender = gender;

	  try {
		if (window.localStorage) {
		  window.localStorage.setItem(STORAGE_KEY, gender);
		}
	  } catch (e) {}

	  //console.log("Gender Saved:", gender);

	  applyPersonalization();

	}

  /*
  =========================================================
  GET GENDER 
  =========================================================
  */

  function getGender() {

	  try {

		if (window.localStorage) {

		  const gender =
			window.localStorage.getItem(STORAGE_KEY);

		  if (gender) {
			memoryGender = gender;
			return gender;
		  }

		}

	  } catch (e) {}

	  return memoryGender;

	}

  /*
  =========================================================
  REPLACE IMAGE PREFIX
  Supports:
  - webp
  - jpg
  - jpeg
  - png
  - gif
  - avif
  - svg
  - Shopify width params 
  - ?v=xxxx
  - srcset
  - relative URLs 
  ========================================================
  */

  function replaceImageUrl(url, gender) {

    if (!url) return url;

    const targetPrefix =
      gender === "male"
        ? "female-"
        : "male-";

    const replacePrefix =
      gender === "male"
        ? "male-"
        : "female-";

    /*
    =========================================================
    REPLACE PREFIX IN FILENAME
    =========================================================
    */

    return url.replace(
      /([\/_\-])(female-|male-)/gi,
      function(match, separator) {

        return separator + replacePrefix;

      }
    );

  }

  /*
  =========================================================
  REPLACE SRCSET URLS
  =========================================================
  */

  function replaceSrcset(srcset, gender) {

    if (!srcset) return srcset;

    return srcset
      .split(",")
      .map(function(item) {

        const parts =
          item.trim().split(" ");

        if (!parts[0]) return item;

        parts[0] =
          replaceImageUrl(
            parts[0],
            gender
          );

        return parts.join(" ");

      })
      .join(", ");

  }

  /*
  =========================================================
  UPDATE IMAGE ATTRIBUTES
  =========================================================
  */

  function updateImageAttributes(img, gender) {

    /*
    =========================================================
    PREPARE SRC + SRCSET
    =========================================================
    */

    const oldSrc = img.getAttribute("src");
    const oldSrcset = img.getAttribute("srcset");

    const newSrc = oldSrc
        ? replaceImageUrl(oldSrc, gender)
        : null;

    const newSrcset = oldSrcset
        ? replaceSrcset(oldSrcset, gender)
        : null;

    /*
    =========================================================
    SRC + SRCSET
    =========================================================
    */

	if (oldSrc && oldSrc !== newSrc) {

			const preload = new Image();

			preload.onload = function () {

				// Save originals only once
				if (!img.dataset.originalSrc) {
					img.dataset.originalSrc = oldSrc;
				}

				if (!img.dataset.originalSrcset) {
					img.dataset.originalSrcset = oldSrcset || "";
				}

				// Extra safety if image later fails
				img.onerror = function () {
					this.onerror = null;

					this.src = this.dataset.originalSrc;

					if (this.dataset.originalSrcset) {
						this.srcset = this.dataset.originalSrcset;
					}
				};

				// Replace only after image exists
				img.src = newSrc;

				if (newSrcset) {
					img.srcset = newSrcset;
				}

			};

			preload.onerror = function () {
				// Male image not found.
				// Keep original female image and srcset.
			};

			preload.src = newSrc;

		}

		/*
		=========================================================
		SHOPIFY LAZYLOAD ATTRIBUTES
		=========================================================
		*/

		[
			"data-src",
			"data-srcset",
			"data-original",
			"data-lazy-src",
			"data-image",
			"data-bg",
			"data-flickity-lazyload",
			"data-widths"
		].forEach(function(attr) {

			const value = img.getAttribute(attr);

			if (!value) return;

			let replaced;

			if (attr.includes("srcset")) {

				replaced = replaceSrcset(
					value,
					gender
				);

			} else {

				replaced = replaceImageUrl(
					value,
					gender
				);

			}

			if (value !== replaced) {

				img.setAttribute(
					attr,
					replaced
				);

			}

		});

	}

  /*
  =========================================================
  REPLACE ALL GENDER IMAGES
  =========================================================
  */

  function replaceGenderImages(
    root = document
  ) {

    const gender =
      getGender();

    if (!gender) return;

    /*
    =========================================================
    IMG TAGS
    =========================================================
    */

    root.querySelectorAll("img")
      .forEach(function(img) {

        updateImageAttributes(
          img,
          gender
        );

      });

    /*
    =========================================================
    SOURCE TAGS (PICTURE)
    =========================================================
    */

    root.querySelectorAll("source")
      .forEach(function(source) {

        if (
          source.getAttribute(
            "srcset"
          )
        ) {

          const oldSrcset =
            source.getAttribute(
              "srcset"
            );

          const newSrcset =
            replaceSrcset(
              oldSrcset,
              gender
            );

          if (
            oldSrcset !==
            newSrcset
          ) {

            source.setAttribute(
              "srcset",
              newSrcset
            );

          }

        }

      });

    /*
    =========================================================
    BACKGROUND IMAGES
    =========================================================
    */

    root.querySelectorAll("*")
      .forEach(function(el) {

        const bg =
          window
            .getComputedStyle(el)
            .backgroundImage;

        if (
          bg &&
          (
            bg.includes(
              "female-"
            ) ||
            bg.includes(
              "male-"
            )
          )
        ) {

          const replaced =
            replaceImageUrl(
              bg,
              gender
            );

          if (bg !== replaced) {

            el.style.backgroundImage =
              replaced;

          }

        }

      });

  }

  /*
  =========================================================
  TESTIMONIAL NAMES
  =========================================================
  */

  function replaceTestimonialNames(
    root = document
  ) {

    const gender =
      getGender();

    if (!gender) return;

    root.querySelectorAll(
      ".image-cards__title"
    ).forEach(function(el) {

      const current =
        el.textContent.trim();

      /*
      =========================================================
      MALE
      =========================================================
      */

      if (
        gender === "male"
      ) {

        if (
          maleNameMap[current]
        ) {

          el.textContent =
            maleNameMap[current];

        }

      }

      /*
      =========================================================
      FEMALE
      =========================================================
      */

      if (
        gender === "female"
      ) {

        Object.keys(
          maleNameMap
        ).forEach(function(
          femaleName
        ) {

          const maleName =
            maleNameMap[
              femaleName
            ];

          if (
            current ===
            maleName
          ) {

            el.textContent =
              femaleName;

          }

        });

      }

    });

  }

  /*
  =========================================================
  GENDER-TARGETED CARDS (Image Cards blocks)
  Hides/shows whole cards based on stored gender.
  Only applies to theme-customizer blocks — cards sourced
  from a metaobject never carry [data-gender-card].
  =========================================================
  */

  function filterGenderCards(
    root = document
  ) {

    const gender =
      getGender();

    const sliders =
      new Set();

    root.querySelectorAll(
      "[data-gender-card]"
    ).forEach(function(card) {

      const target =
        card.closest(".swiper-slide") ||
        card;

      const slider =
        target.closest(
          "[data-image-cards-slider]"
        );

      if (slider) sliders.add(slider);

      const value =
        card.getAttribute(
          "data-gender-card"
        );

      if (
        gender &&
        value &&
        value !== gender
      ) {

        target.style.display = "none";

      } else {

        target.style.removeProperty(
          "display"
        );

      }

    });

    sliders.forEach(function(slider) {

      if (slider.__imageCardsSwiper) {
        slider.__imageCardsSwiper.update();
      }

    });

  }

  /*
  =========================================================
  APPLY ALL PERSONALIZATION
  =========================================================
  */

  function applyPersonalization(
    root = document
  ) {

    replaceGenderImages(root);

    replaceTestimonialNames(root);

    filterGenderCards(root);

  }

  /*
  =========================================================
  POSTSCRIPT EVENT LISTENER
  =========================================================
  */

  window.addEventListener(
    "postscriptPopup",
    function (ev) {

      if (!ev.detail) return;

      function inspect(obj) {

        if (
          !obj ||
          typeof obj !== "object"
        ) return;

        Object.keys(obj)
          .forEach(function(key) {

            const value =
              obj[key];

            if (
              typeof value ===
              "string"
            ) {

              const text =
                value.toLowerCase();

              if (
                text.includes(
                  "female"
                ) ||
                text.includes(
                  "male"
                )
              ) {

                saveGender(
                  text
                );

              }

            }

            if (
              value &&
              typeof value ===
              "object"
            ) {

              inspect(value);

            }

          });

      }

      inspect(ev.detail);

    }
  );

  /*
  =========================================================
  INITIAL PAGE LOAD
  =========================================================
  */

  document.addEventListener(
    "DOMContentLoaded",
    function () {

      applyPersonalization();

    }
  );

  /*
  =========================================================
  OBSERVE DYNAMIC CONTENT
  Nosto, Cart Drawer, Ajax Apps, Shopify Sections
  =========================================================
  */

  const observer =
    new MutationObserver(
      function(mutations) {

        mutations.forEach(
          function(mutation) {

            mutation.addedNodes
              .forEach(function(node) {

                if (
                  node.nodeType === 1
                ) {

                  applyPersonalization(
                    node
                  );

                }

              });

          });

      }
    );

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();

